import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MainLayoutService {
  private _hideTopBar$ = new ReplaySubject<boolean>(1);
  readonly hideTopBar$ = this._hideTopBar$.asObservable();

  hideTopBar(hide: boolean): void {
    this._hideTopBar$.next(hide);
  }
}
